import * as React from 'react';

type TouchEventHandler = (event: TouchEvent) => void;

export function useTouchListeners(
    divRef: React.MutableRefObject<HTMLDivElement | null>,
    handleTouchStart: TouchEventHandler,
    handleTouchEnd: TouchEventHandler
) {
    React.useEffect(() => {
        const element = divRef.current;
        if (!element) return;

        element.addEventListener('touchstart', handleTouchStart);
        element.addEventListener('touchend', handleTouchEnd);

        // Cleanup event listeners on unmount
        return () => {
            element.removeEventListener('touchstart', handleTouchStart);
            element.removeEventListener('touchend', handleTouchEnd);
        };
    }, [divRef, handleTouchEnd, handleTouchStart]);
}
